import React from 'react';

export function AdminDebug() {
  const debugInfo = {
    userAgent: navigator.userAgent,
    protocol: window.location.protocol,
    host: window.location.host,
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    isSecureContext: window.isSecureContext,
    isProd: import.meta.env.PROD,
    mode: import.meta.env.MODE,
  };

  // Only show in development or for debugging
  if (import.meta.env.PROD && !window.location.search.includes('debug=true')) {
    return null;
  }

  return (
    <div className="bg-red-900/20 border border-red-500 rounded-lg p-4 mb-4">
      <h3 className="text-red-400 font-semibold mb-2">Debug Information</h3>
      <div className="text-xs text-red-300 space-y-1">
        {Object.entries(debugInfo).map(([key, value]) => (
          <div key={key}>
            <strong>{key}:</strong> {String(value)}
          </div>
        ))}
      </div>
      {!window.isSecureContext && (
        <div className="mt-2 p-2 bg-red-800 rounded text-red-200">
          ⚠️ Not in secure context - this may cause security errors
        </div>
      )}
    </div>
  );
} 